import { useQuery } from '@apollo/client';
import { graphql } from '@gql/gql';
import { useCallback, useState } from 'react';
import { PAGINATED_SIZE } from '../../ArticleListPageController/constants';
import { useSearch } from '../useSearch';
import { useShelterOrderBuilder } from './useShelterOrderBuilder';
import { useShelterWhereBuilder } from './useShelterWhereBuilder';

export const SHELTER_LIST_GET_SHELTERS = graphql(`
  query ShelterListGetShelters(
    $where: DogShelterWhereInput
    $take: Int
    $skip: Int
    $orderBy: [DogShelterOrderByWithRelationAndSearchRelevanceInput!]
    $translationWhere: DogShelterTranslationWhereInput
  ) {
    findManyDogShelter(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
      ...ShelterCardInfo
    }

    aggregateDogShelter(where: $where) {
      _count {
        _all
      }
    }
  }
`);

export const useGetShelters = () => {
  const [sheltersFetchMoreLoading, setSheltersFetchMoreLoading] = useState(false);
  const { valuesFromSearch } = useSearch();
  const { shelterWhereBuilder } = useShelterWhereBuilder();
  const { shelterOrderBuilder } = useShelterOrderBuilder();

  const { data, error, loading, fetchMore, refetch } = useQuery(SHELTER_LIST_GET_SHELTERS, {
    variables: {
      take: PAGINATED_SIZE,
      skip: 0,
      where: shelterWhereBuilder(valuesFromSearch),
      orderBy: shelterOrderBuilder(),
    },
  });

  const sheltersFetchMore = useCallback(
    async (...args: Parameters<typeof fetchMore>) => {
      setSheltersFetchMoreLoading(true);
      try {
        await fetchMore(...args);
      } finally {
        setSheltersFetchMoreLoading(false);
      }
    },
    [fetchMore],
  );

  return {
    shelters: data?.findManyDogShelter,
    // eslint-disable-next-line no-underscore-dangle
    sheltersCount: data?.aggregateDogShelter?._count?._all ?? 0,
    sheltersError: error,
    sheltersLoading: loading,
    sheltersFetchMore,
    sheltersFetchMoreLoading,
    sheltersRefetch: refetch,
  };
};
